export enum UserRoles {
  performer = "performer",
  spotlight = "spotlight",
  agent = "agent",
  anonymous = "anonymous",
  castingDirector = "castingdirector",
  castingDirectorSearchOnly = "castingdirector:searchonlycastingdirector",
}
